import webLink from '../../assets/images/links/globe2.svg';
import gitLink from '../../assets/images/links/github.svg';
import ytLink from '../../assets/images/links/youtube.svg';

import healthgorilla from '../../assets/images/projects/healthgorilla_cover.png';
import apartmentsite from '../../assets/images/projects/apartment site.png';
import blockchain from '../../assets/images/projects/blockchain.png';
import uhc from '../../assets/images/projects/uhc_cover.png';
import redoxcover from '../../assets/images/projects/redoxcover.png';
import cropperfinance from '../../assets/images/projects/cropper finance.png';
import cignacover from '../../assets/images/projects/cignacover.png';
import euphorusfrontend from '../../assets/images/projects/euphorus frontend.png';
import foxfinance from '../../assets/images/projects/fox finance.png';
import metakongzraffle from '../../assets/images/projects/metakongz raffle.png';
import nftcars from '../../assets/images/projects/NFT cars.png';
import nftminting from '../../assets/images/projects/NFT minting.png';
import ninjachapions from '../../assets/images/projects/ninja champions.png';
import shopify from '../../assets/images/projects/shopify.jpg';
import smaugs from '../../assets/images/projects/smaugs.png';
import solveproblemwithdlops from '../../assets/images/projects/solve problem with dlops.png';
import web3cryptoapp from '../../assets/images/projects/web3 crypto app.png'
import arbachelor from '../../assets/images/projects/bachelor.png';
import smarthome from '../../assets/images/projects/smarthome.png';
import godofwar from '../../assets/images/projects/godofwar.png';
import itlogo from '../../assets/images/projects/intimelogo.png';
import nyoologo from '../../assets/images/projects/ntoologo.png';
import mplogo from '../../assets/images/projects/mplogo.png';
// import discoverro from '../../assets/images/projects/discover-ro.png';
import vclp from '../../assets/images/projects/vclp.png';
import particlehealth from '../../assets/images/projects/particle_health_cover.png';
import SCRIB from '../../assets/images/projects/SCRIBBLETOGETHER.jpg';
import sre from '../../assets/images/projects/select real estate.jpg';
import ob from '../../assets/images/projects/ONCYBER Blockchain.jpg';
import eventalog from '../../assets/images/projects/eventalog.jpg';
import impakt from '../../assets/images/projects/impakt.png';

export const web = [
	{
		name: 'Euphorus Frontend',
		date: '2022-03-20',
		cover: euphorusfrontend,
		links: [
			{ icon: webLink, link: 'https://trusting-babbage-96d918.netlify.app/' },
		],
	},
	{
		name: 'Redox',
		date: '2023-09-06',
		cover: redoxcover,
		links: [
			{ icon: webLink, link: 'https://redoxengine.com/' },
		],
	},
	{
		name: 'Health Gorilla',
		date: '2022-05-08',
		cover: healthgorilla,
		links: [
			{ icon: webLink, link: 'https://www.healthgorilla.com/' },
		],
	},
	{
		name: 'Particle Health',
		date: '2022-05-01',
		cover: particlehealth,
		links: [
			{ icon: webLink, link: 'https://www.particlehealth.com/' },
		],
	},
	{
		name: 'Apartment Site-Generation Martketing',
		date: '2022-04-30',
		cover: apartmentsite,
		links: [{ icon: webLink, link: 'https://www.getflair.io/' }],
	},
	{ 
		name: 'Select Real Estate', 
		date: '2022-03-20', 
		cover: sre, 
		links: [
			{ icon: webLink, link: 'https://selectrealestate.ca/' },
		],
	},
	{
		name: 'Signa',
		date: '2021-11-16',
		cover: cignacover,
		links: [{ icon: webLink, link: 'https://www.cigna.com/' }],
	},
	{
		name: 'Shopify Website',
		date: '2022-05-01',
		cover: shopify,
		links: [
		],
	},
	{ 
		name: 'UnitedHealthcare', 
		date: '2022-03-20', 
		cover: uhc, 
		links: [
			{ icon: webLink, link: 'https://www.uhc.com/' },
		],
	},
	{
		name: 'Eventalog',
		date: '2022-05-01',
		cover: eventalog,
		links: [
			{ icon: webLink, link: 'https://eventalog.com/' },
		],
	},
	{
		name: 'SCRIBBLETOGETHER ',
		date: '2022-05-01',
		cover: SCRIB,
		links: [
			{ icon: webLink, link: 'https://scribbletogether.com/' },
		],
	},	
	{
		name: 'Solve Problem with dlops',
		date: '2022-05-01',
		cover: solveproblemwithdlops,
		links: [
			{ icon: gitLink, link: 'https://dlopsai.netlify.app/' },
		],
	},
];

export const design = [
	{
		name: 'Smart Home Dashboard UI',
		date: '2022-04-03',
		cover: smarthome,
		links: [],
	},
	{
		name: 'God of War Concept UI',
		date: '2022-03-13',
		cover: godofwar,
		links: [],
	},
	{
		name: 'In time Logo',
		date: '2020-04-20',
		cover: itlogo,
		links: [],
	},
	{
		name: 'NY Open Offices Logo',
		date: '2018-05-12',
		cover: nyoologo,
		links: [],
	},
	{
		name: 'Midnight Pulse Logo',
		date: '2018-07-17',
		cover: mplogo,
		links: [],
	},
	{
		name: 'Vice City Conceput UI',
		date: '2022-08-14',
		cover: vclp,
		links: [
			{ icon: ytLink, link: 'https://www.youtube.com/watch?v=ysBkWUQMLHQ' },
		],
	},
];

export const game = [
	{
		name: 'Smaugs',
		date: '2018-12-20',
		cover: smaugs,
		links: [{ icon: webLink, link: 'https://nft.smaugs.com/' }],
	},
	
	{
		name: 'Cropper Finance',
		date: '2017-05-01',
		cover: cropperfinance,
		links: [{ icon: webLink, link: 'https://cropper.finance/' }],
	},
	{
		name: 'Ninja Champions',
		date: '2018-12-20',
		cover: ninjachapions,
		links: [{ icon: webLink, link: 'https://ninjachampions.com/' }],
	},
	{
		name: 'ONCYBER Blockchain ',
		date: '2022-05-01',
		cover: ob,
		links: [
			{ icon: webLink, link: 'https://oncyber.io/' },
		],
	},
	{ name: "Bachelor's degree AR project", date: '2018-07-20', cover: arbachelor, links: [] },
	{ 
		name: "Fox Finance", 
		date: '2020-07-20', 
		cover: foxfinance, 
		links: [
			// { icon: gitLink, link: 'https://github.com/naruhitokaide/foxfinance' },
			{ icon: webLink, link: 'https://foxfinance.io/Marketplace' },
		],
	},
	{
		name: 'Metakongz Raffle',
		date: '2019-01-23',
		cover: metakongzraffle,
		links: [
			{ icon: webLink, link: 'https://metakongz-raffle-auction.vercel.app/raffle' },
		],
	},
	{
		name: 'NFT Cars',
		date: '2019-05-21',
		cover: nftcars,
		links: [{ icon: webLink, link: 'https://nftcars.me/' }],
	},
	{
		name: 'NFT Minting',
		date: '2018-12-20',
		cover: nftminting,
		links: [{ icon: webLink, link: 'https://www.coolsheepnft.com/' }],
	},
	{ 
		name: 'Impakt', 
		date: '2022-03-20', 
		cover: impakt, 
		links: [
			{ icon: webLink, link: 'https://impakt.com/' },
		],
	},
	{
		name: 'Web3 Crypto App',
		date: '2018-12-20',
		cover: web3cryptoapp,
		links: [
			// { icon: gitLink, link: 'https://github.com/naruhitokaide/web3_crypto' },
			{ icon: webLink, link: 'https://web3cryptoapp.vercel.app/' },
		],
	},
	
	{ name: 'Blockchain Platform', date: '2014-09-01', cover: blockchain, links: [{ icon: webLink, link: 'https://trustpad.io/' }], },
];
